/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {makeStyles} from '@material-ui/core/styles';
import {getAssetDetailsContentStyles} from '@ion/dls/src/components/assetdetails/current/assetDetailsContentStyles';

/**
 * Shared current-theme-only styles for a Smarter Trailer section - the
 * Asset Details Drawer card already supplies 16px side padding, so the
 * current theme drops each section's own legacy inner padding instead of
 * doubling up on it, and maps the section's small uppercase text to the
 * drawer's shared label typography.
 *
 * ```typescript
 * import {useSectionStyles} from '@ion/features/src/smarterTrailer/sectionStyles';
 * ...
 *
 * const sectionClasses = useSectionStyles();
 * ```
 */
export const useSectionStyles = makeStyles(() => {
  const contentStyles = getAssetDetailsContentStyles();
  return {
    currentContent : {
      padding : 0
    },
    currentLabel : {
      ...contentStyles.label
    }
  };
});

export default useSectionStyles;
